import { useEffect, useState } from 'react'
import { getRestaurantPage } from 'services/pageService'
import { RestaurantPageProps } from 'types/restaurantPage'

export default function useRestaurantPage() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<RestaurantPageProps | null>(null)

  const fetchData = async () => {
    const items = await getRestaurantPage()

    setData(items as RestaurantPageProps)
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading }
}
